import { createGlobalStyle } from 'styled-components';
import { COLOR } from '@my-portfolio/ui-theme';

// const GlobalStyles = styled.div`
const GlobalStyle = createGlobalStyle`
  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body,
  html {
    width: 100%;
    height: 100%;
    background: ${COLOR.WHITE};
    overscroll-behavior: none;
    margin: 0;
    font-family: "Josefin Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default GlobalStyle;
